import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';



export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

@Injectable({
  providedIn: 'root'
})
export class PendingChangesGuard  {

  canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> {
    return component.canDeactivate() ?
      true :
      confirm('OPGELET! Je wijzigingen zijn nog niet opgeslagen. Deze pagine verlaten en je wijzigingen kwijt geraken?');
  }

}
